import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';

import CreateNewTasksModal from '../../../components/modals/CreateNewTasks';

class ElementCell extends Component {
  static propTypes = {
    onChangeElementCheckbox: PropTypes.func.isRequired,
    isNew: PropTypes.bool,
    elementTypeId: PropTypes.string,
    wbsRootElementId: PropTypes.string,
    // modalOptions: PropTypes.obj,
  };

  constructor(props) {
    super(props);

    this.state = {
      plusButtonDisplay: false,
      showCreateTaskModal: false,
    };

    this._onClick = this._onClick.bind(this);
  }

  _onClick() {
    const { currentRowData, callback } = this.props;

    callback(currentRowData);
  }

  _onChangeCheckBox = event => {
    // console.log(event.target.name, '-', event.target.checked);
    const { onChangeElementCheckbox, currentRowData } = this.props;

    onChangeElementCheckbox(currentRowData.get('id'), event.target.checked);
  };

  handleMouseLeave = () => {
    this.setPlusButtonState(false);
  };
  handleMouseEnter = () => {
    this.setPlusButtonState(true);
  };

  setPlusButtonState = open => {
    const { currentRowData, elementTypeName } = this.props;

    const title = currentRowData.get('title');

    if (
      this.state.showCreateTaskModal === false &&
      (title !== 'Unspecified' || title !== `${elementTypeName}s`)
    ) {
      this.setState({
        plusButtonDisplay: open,
      });
    }
  };

  _addTasksCallback = () => {
    const { addTasksCallback, currentRowData, rowIndex } = this.props;
    addTasksCallback(currentRowData, rowIndex);
  };

  toggleModal = () => {
    this.setState({
      showCreateTaskModal: !this.state.showCreateTaskModal,
      plusButtonDisplay: false,
    });
  };

  render() {
    const {
      currentRowData,
      isNew,
      userMode,
      elementTypeId,
      wbsRootElementId,
      modalOptions,
      selectedTypeMatch,
    } = this.props;
    const { plusButtonDisplay } = this.state;

    if (currentRowData.get('title')) {
      const style = {
        paddingLeft: currentRowData.get('level', 0) * 25,
        fontWeight: 'bold',
        alignItems: 'center',
      };
      const plusButton = (
        <React.Fragment>
          <button
            onClick={this.toggleModal}
            // onClick={this._addTasksCallback}
            className={'action-btn btn btn-success btn-xs'}
            style={{
              marginLeft: 10,
              display: plusButtonDisplay ? 'inline-block' : 'none',
            }}
          >
            <i className={'fa fa-plus'} />
          </button>
          {this.state.showCreateTaskModal && (
            <CreateNewTasksModal
              showModal={this.state.showCreateTaskModal}
              handleCloseModal={this.toggleModal}
              contentLabel="Create New Task(s)"
              typeId={elementTypeId}
              options={modalOptions}
              cb={this.handleMouseLeave}
              wbsRootElementId={wbsRootElementId}
            />
          )}
        </React.Fragment>
      );

      return (
        <div
          style={style}
          className={'row'}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <div>{currentRowData.get('title')}</div>
          {plusButton}
        </div>
      );
    }

    const style = {
      paddingLeft: currentRowData.get('level', 0) * 25,
      // fontWeight: isNew ? 'bold' : 'auto',
      color: selectedTypeMatch ? 'black' : 'gray',
    };

    const displayValue = isNew ? (
      <strong>{currentRowData.get('name')}</strong>
    ) : (
      currentRowData.get('name')
    );

    const checkbox =
      userMode !== 'reader' ? (
        <input
          name={currentRowData.get('icd')}
          type="checkbox"
          onChange={this._onChangeCheckBox}
          value="1"
          disabled={!selectedTypeMatch}
          checked={this.props.isSelected}
        />
      ) : null;

    return (
      <div>
        {checkbox}
        <Link className="list-item-link" onClick={this._onClick}>
          <span style={style}>{displayValue}</span>
        </Link>
      </div>
    );
  }
}

export default ElementCell;



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ElementsByType/ElementCell.js